<template>
  <div id="MainData">
    <vx-card class="shadow-sm">
      
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-full" v-if="opportunity.Id">
          <label>{{ $t('opportunityCode') }}</label>
          <vs-input disabled v-model="opportunity.OpportunityCode" class="w-full" />
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <label>{{ $t("property") }} *</label>
            <v-select 
                :options="properties" 
                :label="currentLocale === 'ar' ? 'PropertyNameAr' : 'PropertyNameEn'" 
                v-model="opportunity.PropertyId" 
                :reduce="p => p.Id" 
              />          <span class="text-danger" v-if="!opportunity.PropertyId">{{ RequiredMessage }}</span>
        </div>
        <div class="vx-col md:w-1/4 w-full">
          <label>{{ $t("status") }} *</label>
        <v-select 
            :options="statuses" 
            :label="currentLocale === 'ar' ? 'NameAr' : 'NameEn'" 
            v-model="opportunity.OpportunityStatusId" 
            :reduce="s => s.Id" 
          />         
     <span class="text-danger" v-if="!opportunity.OpportunityStatusId">{{ RequiredMessage }}</span>
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col md:w-1/2 w-full">
          <label>{{ $t('opportunityNameAr') }} *</label>
          <vs-input v-model="opportunity.OpportunityNameAr" class="w-full" />
          <span class="text-danger" v-if="!opportunity.OpportunityNameAr">{{ RequiredMessage }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <label>{{ $t('opportunityNameEn') }}</label>
          <vs-input v-model="opportunity.OpportunityNameEn" class="w-full" />
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col md:w-1/3 w-full">
          <label>{{ $t('offeringValue') }}</label>
          <vs-input type="number" v-model="opportunity.OfferingValue" class="w-full" />
        </div>
        <div class="vx-col md:w-1/3 w-full">
          <label>{{ $t('totalTokens') }} *</label>
          <vs-input type="number" v-model="opportunity.TotalTokens" class="w-full" />
          <span class="text-danger" v-if="!opportunity.TotalTokens">{{ RequiredMessage }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-full">
          <label>{{ $t('tokenPrice') }} *</label>
          <vs-input type="number" v-model="opportunity.TokenPrice" class="w-full" />
          <span class="text-danger" v-if="!opportunity.TokenPrice">{{ RequiredMessage }}</span>
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col md:w-1/4 w-full">
          <label>{{ $t('currencyCode') }}</label>
          <vs-input v-model="opportunity.CurrencyCode" class="w-full" />
        </div>
        <div class="vx-col md:w-1/4 w-full">
          <label>{{ $t('minPurchaseTokens') }}</label>
          <vs-input type="number" v-model="opportunity.MinPurchaseTokens" class="w-full" />
        </div>
        <div class="vx-col md:w-1/4 w-full">
          <label>{{ $t('maxPurchaseTokens') }}</label>
          <vs-input type="number" v-model="opportunity.MaxPurchaseTokens" class="w-full" />
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col md:w-1/2 w-full">
          <label>{{ $t("subscriptionStart") }}</label>
          <datepicker :append-to-body="true" v-model="opportunity.SubscriptionStartAt" class="w-full" />
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <label>{{ $t("subscriptionEnd") }}</label>
          <datepicker :append-to-body="true" v-model="opportunity.SubscriptionEndAt" class="w-full" />
        </div>
      </div>

        <div class="vx-col md:w-1/4 w-full mb-4">
          <label class="text-sm opacity-75">{{ $t('commissionPercentage') }} *</label>
          <vs-input type="number" min="0" max="100" v-model.number="opportunity.CommissionPercentage" class="w-full mt-1" icon-pack="feather" icon="icon-percent" placeholder="0.00" />
          <span class="text-danger text-xs" v-if="opportunity.CommissionPercentage === null || opportunity.CommissionPercentage === ''">{{ RequiredMessage }}</span>
        </div>

    </vx-card>

    <div class="vx-row mb-4 ml-10">
      <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button
          type="border"
          icon-pack="feather"
          icon="icon-arrow-left"
          @click="cancel"
          class="px-4 w-full md:w-auto mr-6"
        >
          {{ $t("Back") }}</vs-button
        >
        <vs-button          
          :disabled="!isFormValid"
          @click="submitData"
          >{{ $t("SaveChanges") }}</vs-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import VxCard from "../../components/vx-card/VxCard.vue";
import { domain } from "@/gloabelConstant.js";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import moduleProperties from "@/store/Properties/moduleProperties.js";
import moduleOpportunityStatus from "@/store/OpportunityStatus/moduleOpportunityStatus.js";
import moduleOpportunities from "@/store/Opportunities/moduleOpportunities.js";

export default {
  components: {
    VxCard,
    Datepicker,
    vSelect
  },
  props: {
    opportunity: {
      type: Object,
      required: true,
    }
  },


  data() {
    return {
      baseURL: domain,
      userInfo: {},
      RequiredMessage: "This Field Is Required",

      
    };
  },

  computed: {

    currentLocale() {
        return this.$i18n.locale;
      },
    properties() {
      return this.$store.state.PropertiesList.Properties;
    },


    statuses() {
      return this.$store.state.OpportunityStatusList.OpportunityStatusList;
    },


    isFormValid() {
      
  const basicValidation =
    !this.errors.any() 
     && this.opportunity.PropertyId
     && this.opportunity.OpportunityNameAr
     && this.opportunity.OpportunityNameEn
     && this.opportunity.OfferingValue
     && this.opportunity.TotalTokens
     && this.opportunity.TokenPrice
     && this.opportunity.CurrencyCode
     && this.opportunity.MinPurchaseTokens
      && this.opportunity.MaxPurchaseTokens
      && this.opportunity.SubscriptionStartAt
      && this.opportunity.SubscriptionEndAt
      && this.opportunity.OpportunityStatusId
      && (this.opportunity.CommissionPercentage !== null && this.opportunity.CommissionPercentage !== '');
  return (
    basicValidation 
   
  );
}
  },

  methods: {

    initValues() {
      this.opportunity = {
        PreviousEvents: [],
        PreviousOutbreaks: [],
        CommissionPercentage: 0, 
      };


    },
    submitData() {
      
      this.$validator.validateAll().then((result) => {
        if (result) {
          
          if (this.opportunity.Id !== null && this.opportunity.Id > 0) {
            this.$vs.loading();
            this.$store
              .dispatch("OpportunitiesList/updateItem", this.opportunity)
              .then(() => {
                this.$vs.loading.close();
                this.$store.dispatch("OpportunitiesList/fetchDataListItems");
                this.showSuccess();
                this.cancel();
                this.initValues();
              })
              .catch((err) => {
                
                this.$vs.notify({
                  time: 2500,
                  title: "Error",
                  text: err.response.data.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                });
                console.error(err);
                this.$vs.loading.close();
              });
          } else {
            
            this.$store
              .dispatch("OpportunitiesList/addItem", this.opportunity)
              .then(() => {
                
                this.$store.dispatch("OpportunitiesList/fetchDataListItems");
                this.showSuccess();
                this.cancel();
                this.initValues();
              })
              .catch((err) => {
                

                this.$vs.notify({
                  time: 2500,
                  title: "Error",
                  text: err.response.data.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                });
                console.error(err);
                this.$vs.loading.close();
              });
          }
        }
      });
    },

    showSuccess() {
      this.$vs.notify({
        time: 2500,
        title: "Success",
        text: "Saved Successfully",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success",
      });
    },

    reset_data() {
      this.initValues();
    },
    cancel() {
      this.$router.go(-1);
    },
  

  },

  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));

  if (!moduleOpportunities.isRegistered) {
      this.$store.registerModule("OpportunitiesList", moduleOpportunities);
      moduleOpportunities.isRegistered = true;
    } 

       if (!moduleProperties.isRegistered) {
      this.$store.registerModule("PropertiesList", moduleProperties);
      moduleProperties.isRegistered = true;
    } 
    this.$store.dispatch("PropertiesList/fetchDataListItems");

     if (!moduleOpportunityStatus.isRegistered) {
      this.$store.registerModule("OpportunityStatusList", moduleOpportunityStatus);
      moduleOpportunityStatus.isRegistered = true;
    } 
    this.$store.dispatch("OpportunityStatusList/fetchDataListItems");
  },

  mounted() {
    this.isMounted = true;
  }
};
</script>


<style lang="scss">

#MainData {
  .vs-input--input, .vs__dropdown-toggle, .vdp-datepicker input {
    border: 1px solid rgba(0, 0, 0, 0.1) !important;
    border-radius: 6px !important; 
    height: 38px !important; 
    padding: 0.6rem !important;
    box-shadow: none !important;
    font-size: 0.9rem;
  }


  label {
    font-weight: 500;
    color: #555;
    margin-bottom: 4px;
    display: block;
    font-size: 0.85rem;
  }


  .vx-row {
    margin-bottom: 0.5rem !important;
  }


  .text-danger {
    font-size: 0.75rem;
    margin-top: 2px;
    display: block;
  }

  .vdp-datepicker__calendar {
    position: absolute;
    z-index: 999999 !important;
    bottom: 100%;
    left: 0;
    background: white;
    box-shadow: 0 5px 25px rgba(0,0,0,0.1);
    border: 1px solid #ddd !important;
    border-radius: 8px;
}


.vx-card {
    overflow: visible !important;
}

.vx-card__collapsible-content {
    overflow: visible !important;
}
}
</style>